import axios from 'axios'

export default {
  getExportFields: () => axios.get('export_fields'),
  getFileFormat: (id) => axios.get(`/export_fields_mappings/${id}`),
  getFileFormats: (filters = {}, pagination = false, page = 1) => axios.get('/export_fields_mappings', { params: { page: page, pagination: pagination, ...filters } }),
  postFileFormat: (fileFormat) => axios.post('/export_fields_mappings', fileFormat),
  putFileFormat: (id, fileFormat) => axios.put(`/export_fields_mappings/${id}`, fileFormat),
  deleteFileFormat: (id) => axios.delete(`/export_fields_mappings/${id}`, {}),
  getFieldMapping: (id) => axios.get(`/mapping_configurations/${id}`),
  getFieldsMapping: (filters = {}, pagination = false, page = 1) => axios.get('/mapping_configurations', { params: { page: page, pagination: pagination, ...filters } }),
  putFieldMapping: (id, fieldMapping) => axios.put(`/mapping_configurations/${id}`, fieldMapping),
  postFieldMapping: (fieldMapping) => axios.post('/mapping_configurations', fieldMapping),
  deleteFieldMapping: (id) => axios.delete(`/mapping_configurations/${id}`, {})
}
